import request from '@/ajax'
/**
 * 获取vip等级信息
 */
export function vipList() {
    return request('/VipNew/vipList');
}
export function vipRightsList(query) {
    return request('/VipNew/vipRightsList', query);
}

export function vipExplain() {
    return request('/VipNew/vipExplain')
}
//用户成长值明细
export function userGrowthValueLog(query) {
    return request('/VipNew/userGrowthValueLog',query)
}

export function userVipInfo() {
    return request('/VipNew/userVipInfo')
}